import React, { Component } from "react";
import styles from "./reportContructor.module.scss";
import { Radio } from "@mui/material";

class ReportConstructrSwitcher extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isPatternListOpen: true,
    };
  }

  onHandleSwithcer(isPatternListOpen) {
    const { onChange } = this.props;

    onChange(isPatternListOpen);
  }

  render() {
    const { isPatternListOpen } = this.props;

    return (
      <div className={styles.reportConstructrSwitcherContainer}>
        <div className={styles.radioButtomContainer}>
          <div
            onClick={() => {
              this.onHandleSwithcer(true);
            }}
          >
            <Radio checked={isPatternListOpen} size="small" /> Шаблоны
          </div>
          <div
            onClick={() => {
              this.onHandleSwithcer(false);
            }}
          >
            <Radio checked={!isPatternListOpen} size="small" title="Шаблоны" /> Пользовательские отчеты
          </div>
        </div>
      </div>
    );
  }
}

export default React.memo(ReportConstructrSwitcher);
